import { NavLink, Outlet } from "react-router-dom";

const SUB_NAV = [
  { path: "/knowledge", label: "Hub", end: true },
  { path: "/knowledge/manage", label: "Manage", end: false },
];

export function KnowledgeLayout() {
  return (
    <div>
      <div className="border-b border-zinc-200 bg-white">
        <div className="mx-auto flex max-w-7xl gap-1 px-6 pt-4">
          {SUB_NAV.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.end}
              className={({ isActive }) =>
                `border-b-2 px-3 py-2 text-sm font-medium transition ${
                  isActive
                    ? "border-zinc-900 text-zinc-900"
                    : "border-transparent text-zinc-500 hover:text-zinc-800"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </div>
      </div>
      <Outlet />
    </div>
  );
}
